/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "nowrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

export default function Table10({ formData, setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      nameNNT: "",
      addressNNT: "",
      country: "",
      incomeAbroad: 0,
      incomeTaxPaidAbroad: 0,
      incomeTaxes: 0,
      determineIncomeTaxA: 20,
      determineIncomeTaxB: 0,
      determineIncomeTaxC: 0,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);
  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        nameNNT: "",
        addressNNT: "",
        country: "",
        incomeAbroad: 0,
        incomeTaxPaidAbroad: 0,
        incomeTaxes: 0,
        determineIncomeTaxA: 20,
        determineIncomeTaxB: 0,
        determineIncomeTaxC: 0,
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };
  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", minWidth: 10 }}
              >
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Tên của NNT khấu trừ thuế ở nước ngoài
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Địa chỉ NNT khấu trừ thuế ở nước ngoài
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Quốc gia
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Thu nhập nhận được ở nước ngoài
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Thuế thu nhập đã nộp ở nước ngoài cho phần thu nhập nhận được
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Thu nhập chịu thuế theo Luật thuế TNDN
              </Td>
              <Td rowSpan={1} colSpan={3} style={{ textAlign: "center" }}>
                Xác định thuế thu nhập đã nộp ở nước ngoài được trừ
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>Thuế suất thuế TNDN (%)</Td>
              <Td style={{ textAlign: "center" }}>Số thuế phải nộp theo luật thuế TNDN</Td>
              <Td style={{ textAlign: "center" }}>Số thuế đã nộp ở nước ngoài được trừ</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>(1)</Td>
              <Td style={{ textAlign: "center" }}>(2a)</Td>
              <Td style={{ textAlign: "center" }}>(2b)</Td>
              <Td style={{ textAlign: "center" }}>(2c)</Td>
              <Td style={{ textAlign: "center" }}>(3)</Td>
              <Td style={{ textAlign: "center" }}>(4)</Td>
              <Td style={{ textAlign: "center" }}>(5)=(3)+(4)</Td>
              <Td style={{ textAlign: "center" }}>(6)</Td>
              <Td style={{ textAlign: "center" }}>(7)=(5)x(6)</Td>
              <Td style={{ textAlign: "center" }}>(8)</Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="nameNNT"
                    value={item.nameNNT}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="addressNNT"
                    value={item.addressNNT}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "country", e.target.value)}
                  >
                    <option value="value1">Quốc gia 1</option>
                    <option value="value2">Quốc gia 2</option>
                    <option value="value3">Quốc gia 3</option>
                    <option value="value4">Quốc gia 4</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="incomeAbroad"
                    value={item.incomeAbroad}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="incomeTaxPaidAbroad"
                    value={item.incomeTaxPaidAbroad}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    style={{
                      background: "#ddeff3",
                      border: 0,
                      textAlign: "left",
                      width: "100%",
                    }}
                    id={item.id}
                    name="incomeTaxes"
                    value={item.incomeTaxes}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="determineIncomeTaxA"
                    value={item.determineIncomeTaxA}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    style={{
                      background: "#ddeff3",
                      border: 0,
                      textAlign: "left",
                      width: "100%",
                    }}
                    id={item.id}
                    name="determineIncomeTaxB"
                    value={item.determineIncomeTaxB}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="determineIncomeTaxC"
                    value={item.determineIncomeTaxC}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
            <tr key={1000}>
              <Td
                className="toggle-button"
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                Tổng cộng:
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                <InputTable
                  style={{
                    background: "#ddeff3",
                    textAlign: "right",
                    fontWeight: "bold",
                    width: "100%",
                    border: 0,
                  }}
                  value={0}
                />
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
